module.exports = ".select-placeholder {\n    color: lightgray;\n}"